import { uploadBannerImageElite } from "services/uploadFileElite";
import { stripEliteBannerName } from "../constants/eliteSite";

const PREVIEW_KEYS = ["mobile", "tablet", "pc", "large"];

const API_KEY_MAP = {
  mobile: "img_mobile",
  tablet: "img_tablet",
  pc: "img_pc",
  large: "img_large",
};

const normalizeBannerElite = (raw) => ({
  id: raw.id,
  form: {
    name: stripEliteBannerName(raw.name || ""),
    link: raw.link || "",
    order: raw.order ?? "",
    startDate: raw.start_date ? String(raw.start_date).split("T")[0] : "",
    endDate: raw.end_date ? String(raw.end_date).split("T")[0] : "",
  },
  previews: {
    mobile: raw.img_mobile || null,
    tablet: raw.img_tablet || null,
    pc: raw.img_pc || null,
    large: raw.img_large || null,
  },
});

const normalizeBannerEliteForCarousel = (raw) => ({
  id: raw.id,
  form: {
    link: raw.link || "",
    name: raw.name || "",
    startDate: raw.start_date ? String(raw.start_date).split("T")[0] : "",
    endDate: raw.end_date ? String(raw.end_date).split("T")[0] : "",
  },
  previews: {
    mobile: raw.img_mobile || null,
    tablet: raw.img_tablet || null,
    pc: raw.img_pc || null,
    large: raw.img_large || null,
  },
});

const filterActiveBannersElite = (banners) => {
  const now = new Date();

  return banners.filter((banner) => {
    const start = banner.form.startDate ? new Date(banner.form.startDate) : null;
    const end = banner.form.endDate ? new Date(banner.form.endDate) : null;

    if (start && now < start) return false;
    if (end && now > end) return false;
    return true;
  });
};

const buildBannerElitePayload = async (form, previews, files, { isEdit = false } = {}) => {
  const payload = {
    name: form.name.trim(),
    link: form.link || "",
    order: parseInt(form.order, 10),
  };

  if (!payload.order || payload.order < 1) {
    throw new Error("El orden es obligatorio y debe ser un número mayor a 0.");
  }

  if (form.startDate) payload.start_date = form.startDate;
  if (form.endDate) payload.end_date = form.endDate;

  for (const key of PREVIEW_KEYS) {
    const apiKey = API_KEY_MAP[key];

    if (files[key] instanceof File) {
      const url = await uploadBannerImageElite(files[key]);
      payload[apiKey] = url;
      continue;
    }

    if (typeof previews[key] === "string" && previews[key].startsWith("http")) {
      payload[apiKey] = previews[key];
    }
  }

  const missing = PREVIEW_KEYS.filter((key) => !payload[API_KEY_MAP[key]]);

  if (!isEdit && missing.length > 0) {
    throw new Error(
      "Debes subir las 4 imágenes: móvil, tablet, PC y pantalla grande.",
    );
  }

  if (isEdit && missing.length > 0) {
    throw new Error(
      `Faltan imágenes en: ${missing.map((k) => API_KEY_MAP[k]).join(", ")}`,
    );
  }

  return payload;
};

const getBannerEliteErrorMessage = (error, fallback) => {
  const data = error?.response?.data;

  if (typeof data === "string" && data.trim()) {
    return data.trim();
  }

  if (data?.message) {
    return data.message;
  }

  if (error?.message) {
    return error.message;
  }

  return fallback;
};

export {
  normalizeBannerElite,
  normalizeBannerEliteForCarousel,
  filterActiveBannersElite,
  buildBannerElitePayload,
  getBannerEliteErrorMessage,
};
